import plugin from '../src/style-observer.plugin.js';

(typeof gobalThis !== 'undefined' ? globalThis : window).gySVG.extend (plugin);
